import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FilterRequests } from '../../services/filter-requests.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { FiltersService } from '../../services/filters.service';

export interface BenchmarkOption {
  value: string;
  label: string;
}

@Component({
    selector: 'benchmark',
    templateUrl: './benchmark.component.html',
    styleUrls: ['./benchmark.component.scss'],
    standalone: false
})
export class BenchmarkComponent implements OnInit {

  @Input() title: string = 'Benchmark';
  @Input() filters: ContractModel | undefined;
  
  @Output() onClose = new EventEmitter<void>();
  @Output() onProceed = new EventEmitter<string>();

  selectedOption: string = '';
  benchmarkOptions: BenchmarkOption[] = [];
  isLoadingOptions: boolean = false;
  showSelectError: boolean = false;

  constructor(private filterRequestsService: FilterRequests, private filtersService: FiltersService) {}

  ngOnInit(): void {
    // Reset selected option when component initializes
    this.selectedOption = '';
    
    if (this.filters) {
      this.loadBenchmarkOptions();
    }
  }

  async loadBenchmarkOptions(): Promise<void> {
    if (!this.filters) {
      console.log('No filters available');
      return;
    }
    
    this.isLoadingOptions = true;
    
    try {
      let benchmarkOptions: string[];
      // Check if data already exists in the BehaviorSubject
      benchmarkOptions = this.filtersService.getBenchmarkOptions();

      if (benchmarkOptions && benchmarkOptions.length == 0) {
        // Call the API to get benchmark options
        benchmarkOptions = await this.filterRequestsService.getFilterOptionsByFilterType(
          this.filters.division,
          'ThirdLevelContractFilter',
          this.filters.topLevelContractGroup,
          this.filters.secondLevelContractFilter,
          this.filters.thirdLevelContractFilter,
          this.filters.fourthLevelContractFilter,
          this.filters.regions || [],
          this.filters.countries || []
        );
        
        // Store the response in the FiltersService BehaviorSubject
        this.filtersService.setBenchmarkOptions(benchmarkOptions);
      }
      
      // Transform the API response to BenchmarkOption format
      this.benchmarkOptions = benchmarkOptions.map((benchmarkOption: string) => {
        return {
            value: benchmarkOption,
            label: benchmarkOption
          };
      });      
    } catch (error) {
      console.error('Error loading benchmark options:', error);
      // Clear the benchmark subject on error
      this.filtersService.setBenchmarkOptions([]);
    } finally {
      this.isLoadingOptions = false;
    }
  }

  onOptionChange(event: any): void {
    this.selectedOption = event.target.value;
    this.showSelectError = false;
  }

  closeBenchmark(): void {
    this.onClose.emit();
  }

  proceedWithDownload(): void {
    // Validate that an option is selected before proceeding
    if (!this.selectedOption) {
      this.showSelectError = true;
      return;
    }
    this.showSelectError = false;
    // Emit the selected option to the parent component
    this.onProceed.emit(this.selectedOption);
  }

}